// extracted by mini-css-extract-plugin
export default {"menuAnchor":"D8JoD1NgonU1B9eX1SVH","menuOpen":"kI0g87nZipiarukz3tpt","popup":"XdbhOhMK9h6V8LkOIWn1"};